import React from "react";
import TptImg from "images/components/testimonials/tpt.svg";
import PropTypes from "prop-types";
import classnames from "classnames";
import Quote from "./Quote";
import ReviewStar from "./ReviewStar";

const teacherQuotes = [
  {
    author: "Maria S.",
    text: "This is a fantastic resource! It will also save hours of prep time!",
    title: "High School Teacher"
  },
  {
    author: "Kara B.",
    text: "This has been an essential resource for me. I've already recommended LitCharts to colleagues!",
    title: "Middle School Teacher"
  }
];

const generalQuotes = [
  {
    author: "Harry S.",
    text: "I absolutely love LitCharts. You guys really helped me get the highest possible grade.",
    title: "Student"
  },
  {
    author: "Maria S.",
    text: "This is a fantastic resource! It will also save hours of prep time!",
    title: "Teacher"
  }
];

export default function Testimonials({ planType }) {
  const bgColor =
    planType === "general"
      ? "tw-bg-purple-tint-95"
      : "tw-bg-light-teal-tint-95";
  const reviewCardBorderColor =
    planType === "general"
      ? "tw-border-purple-tint-50"
      : "tw-border-light-teal-tint-50";

  const quotes = planType === "general" ? generalQuotes : teacherQuotes;

  return (
    <div
      className={classnames(
        bgColor,
        "tw-flex tw-flex-col tw-gap-[15px] tw-max-w-[410px] tw-rounded-lg tw-p-[15px] tw-mx-[15px]",
        "sm:tw-max-w-[890px] sm:tw-flex-row sm:tw-gap-4 sm:tw-p-5"
      )}
    >
      <div
        className={classnames(
          reviewCardBorderColor,
          "tw-flex tw-flex-col tw-items-center",
          "tw-border tw-border-solid tw-rounded-lg tw-bg-white",
          "tw-h-[162px] tw-pt-[30px] tw-pb-9 tw-px-[15px]",
          "sm:tw-px-[30px] sm:tw-pt-10 sm:tw-pb-12 sm:tw-h-full"
        )}
      >
        <div className="tw-font-serif">
          <span className="title-2 tw-text-green-shade-40">2,700+</span>
          <span className="title-5 tw-text-teal-shade-20"> reviews</span>
        </div>
        <div
          className={classnames(
            "tw-flex tw-justify-center tw-items-center tw-gap-2",
            "tw-my-1 tw-pl-2 tw-pr-3 tw-py-1.25",
            "tw-bg-purple-tint-95 tw-rounded-[70px] tw-shadow-[0_1px_4px_0_rgba(24,25,25,0.3)]",
            "sm:tw-gap-3 sm:tw-pl-3 sm:tw-pr-4 sm:tw-py-1.75 sm:tw-mt-2"
          )}
        >
          <div className="tw-flex tw-bg-purple-tint-95 tw-pb-0.5 tw-gap-1 tw-text-blue sm:tw-gap-2">
            <ReviewStar />
            <ReviewStar />
            <ReviewStar />
            <ReviewStar />
            <ReviewStar />
          </div>
          <span className="title-6 tw-text-purple-shade-40 tw-whitespace-nowrap tw-pt-0.25 sm:tw-pt-0.5">
            4.8 out of 5
          </span>
        </div>
        <div className="tw-flex tw-gap-1.5 tw-items-center">
          <span className="subtitle-1">based on surveys and</span>
          <img
            className="tw-w-[60px] tw-h-4"
            src={TptImg}
            alt="teachers pay teachers logo"
          />
        </div>
      </div>
      <div className="tw-flex tw-gap-[15px] tw-bg-purple-tint-95 tw-flex-col tw-justify-center sm:tw-gap-5">
        {quotes.map((quote) => (
          <Quote key={quote.author} {...quote} />
        ))}
      </div>
    </div>
  );
}

Testimonials.propTypes = {
  planType: PropTypes.oneOf(["general", "teacher"])
};

Testimonials.defaultProps = {
  planType: "general"
};
